import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Container, Heading } from '@chakra-ui/react';
import CTA from './cta';
import FAQ from './faq';
import Features from './features';
import Footer from '../../layout/footer/footer';
import Hero from './hero';
import Jackpot from './jackpot';
import Navbar from '../../layout/navbar/navbar';
import Pricing from '../subscribe/pricing-table';
import balls from '../../../public/landing/balls.svg';
import { useRouter } from 'next/router';
export function Landing(props) {
  var router = useRouter();

  var handleSelectPlan = function handleSelectPlan() {
    router.push('/signup');
  };

  return /*#__PURE__*/_jsx(Box, {
    style: {
      background: "url(".concat(balls.src, ")")
    },
    children: /*#__PURE__*/_jsxs(Container, {
      maxW: "5xl",
      children: [/*#__PURE__*/_jsx(Navbar, {
        items: [{
          label: 'Features',
          href: '#features'
        }, {
          label: 'Pricing',
          href: '#pricing'
        }]
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Hero, {})
      }), /*#__PURE__*/_jsx(Box, {
        as: "section",
        id: "features",
        my: 10,
        py: 10,
        children: /*#__PURE__*/_jsx(Features, {})
      }), /*#__PURE__*/_jsx(Box, {
        as: "section",
        my: 10,
        py: 10,
        children: /*#__PURE__*/_jsx(Jackpot, {})
      }), /*#__PURE__*/_jsxs(Box, {
        as: "section",
        id: "pricing",
        my: 10,
        py: 10,
        children: [/*#__PURE__*/_jsx(Heading, {
          align: 'center',
          fontWeight: 900,
          mb: 5,
          children: "Our pricing"
        }), /*#__PURE__*/_jsx(Pricing, {
          products: props.products,
          onSelectPlan: handleSelectPlan
        })]
      }), /*#__PURE__*/_jsx(Box, {
        as: "section",
        id: "faq",
        my: 10,
        py: 10,
        children: /*#__PURE__*/_jsx(FAQ, {})
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(CTA, {})
      }), /*#__PURE__*/_jsx(Box, {
        mt: "10",
        children: /*#__PURE__*/_jsx(Footer, {})
      })]
    })
  });
}
export default Landing;